import {
  compose
} from 'recompose';
import { connect } from 'react-redux';
import ContentQuestion from './../shared/publish-content/content-question';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';

const mapStateToProps = (state) => ({
  selectedContent: state.publisherPortal.content.selectedContent,
  contentError: state.publisherPortal.content.error,
  contentQuestions: state.publisherPortal.content.contentQuestions,
  saveQuestionSuccess: state.publisherPortal.content.saveQuestionSuccess,
  libraryRouteRoot: routes.publisherPortal,
  isFetchingContent: state.publisherPortal.content.isFetching
});

const mapDispatchToProps = (dispatch) => ({
  getContent: bindActionCreators(publisherPortalActions.publisherPortal.content.getById, dispatch),
  resetSelectedContent: bindActionCreators(publisherPortalActions.publisherPortal.content.resetSelectedContent, dispatch),
  getContentQuestions: bindActionCreators(publisherPortalActions.publisherPortal.content.getContentQuestions, dispatch),
  deleteContentQuestion: bindActionCreators(publisherPortalActions.publisherPortal.content.deleteQuestion, dispatch),
  saveContent: bindActionCreators(publisherPortalActions.publisherPortal.content.saveContent, dispatch),
  saveQuestion: bindActionCreators(publisherPortalActions.publisherPortal.content.saveQuestion, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ContentQuestion);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/content-question.js